var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLogoTwitter = function SvgIconLogoTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.921 21.125c8.3 0 12.84-6.878 12.84-12.84 0-.194-.003-.392-.012-.585A9.168 9.168 0 0 0 23 5.363a8.9 8.9 0 0 1-2.59.71 4.538 4.538 0 0 0 1.984-2.497 9.072 9.072 0 0 1-2.865 1.095 4.52 4.52 0 0 0-7.694 4.116 12.82 12.82 0 0 1-9.301-4.712 4.519 4.519 0 0 0 1.396 6.022 4.52 4.52 0 0 1-2.045-.562v.055a4.512 4.512 0 0 0 3.622 4.426 4.486 4.486 0 0 1-2.037.078 4.523 4.523 0 0 0 4.215 3.136A9.052 9.052 0 0 1 1 19.098a12.804 12.804 0 0 0 6.921 2.027Z",
    fill: "#A4A7AD"
  })));
};
export default SvgIconLogoTwitter;